import React from 'react';
import styled, { css } from 'styled-components';

type TypographyProps = {
  color?: string;
  size?: string;
  fontWeight?: string;
};

export const Typography = styled.p<TypographyProps>`
  ${({ theme, color, size, fontWeight }) => css`
    color: ${color ? color : theme.colors.blueEinstein};
    size: ${size ? size : theme.colors.blueEinstein};
    font-weight: ${fontWeight ? fontWeight : '200'};
  `}
`;
